import * as React from 'react';
import { T } from '../../../Translations';

interface Props {
  total: number;
  off: number;
}

// One chip carrying both the roll-up and the count, so the header does not
// need a separate number beside it. Neutral while everything in the section is
// sending; marked once anything is off.
const SectionChip: React.FC<Props> = ({ total, off }) => {
  if (off === 0) {
    return (
      <span
        className="inline-flex items-center px-2 py-0.5 rounded-full whitespace-nowrap bg-background text-muted-foreground border border-border tabular-nums"
        style={{ fontSize: '11px', fontWeight: 'var(--font-weight-medium)' }}
      >
        {total}
      </span>
    );
  }

  if (off === total) {
    return (
      <span
        className="inline-flex items-center px-2 py-0.5 rounded-full whitespace-nowrap bg-muted-foreground text-background normal-case"
        style={{ fontSize: '11px', fontWeight: 'var(--font-weight-medium)' }}
      >
        <T kind="All off" />
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full whitespace-nowrap bg-background text-foreground border border-muted-foreground normal-case tabular-nums"
      style={{ fontSize: '11px', fontWeight: 'var(--font-weight-medium)' }}
    >
      <span>{off}</span>
      <span>
        <T kind="off" />
      </span>
    </span>
  );
};

export default SectionChip;
